var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"suggest-list"},_vm._l((_vm.suggestList),function(item){return _c('li',{key:item.value,staticClass:"suggest-item"},[_vm._t("suggest",[_c('span',{domProps:{"innerHTML":_vm._s(item.text)}})],{"suggest":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }